import { observer } from "mobx-react";
import React from "react";
import LoadingIndicatorWrapper from "../Components/LoadingIndicatorWrapper";
import MainArea from "../Components/MainArea";
import MainWrapper from "../Components/MainWrapper";
import Sidebar from "../Components/Sidebar";
import StepsNavigation from "../Components/StepsNavigation";
import "./ConfigurationPage.css";
import { generalConfigurationStore } from "../Stores/GeneralConfigurationStore";

// declare props (data passed from outside the component)
type Props = {
};

// declare state (internal component state)
type State = {
	title: string;
	pageIsActive: number;
};

@observer
class ConfigurationPage extends React.Component<Props, State> {
	configurationRef: any;

	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {
			title: "ConfigurationPage",
			pageIsActive: 1,
		};

		this.configurationRef = React.createRef(); // Create a ref object
	}

	// react lifecycle method
	componentDidMount() {
		// always use this.setState({}) when updating something in state
		this.setState({
			title: "ConfigurationPage Loaded",
		});

		// if url has hashtag, find element and jump to it
		const anchor = window.location.hash;

		if (anchor !== "") {
			const id = anchor.replace("#", "");
			const domElement = document.getElementById(id);

			if (domElement) {
				domElement.scrollIntoView();
			}
		} else {
		}
	}

	render() {

		let marginTop = 0
		if (window.innerWidth < 992) {
			marginTop = generalConfigurationStore.isPreviewSticky ? generalConfigurationStore.previewContentHeight : 0
		}
		
		const productConfigurationStore = generalConfigurationStore.productConfigurationStore
		if (!productConfigurationStore) 
			return <div/>

		return (
			<div className="configuration-page" ref={this.configurationRef}>
				{productConfigurationStore.isLoading ? (
					<LoadingIndicatorWrapper />
				) : (
					<div 
						style={{ marginTop }}
						className={`${generalConfigurationStore.isPreviewOpen ? "preview-open" : ""} ${generalConfigurationStore.isPreviewSticky ? "preview-sticky" : ""}`}>
						<StepsNavigation pageIsActive={this.state.pageIsActive}></StepsNavigation>
						<MainWrapper>
							<MainArea></MainArea>
							<Sidebar productConfigurationStore={productConfigurationStore}></Sidebar>
						</MainWrapper>
					</div>
				)}
			</div>
		);
	}
}

export default ConfigurationPage;
